import axios, { type AxiosResponse } from 'axios';
import { hidePageLoading, showPageLoading, showToastMessage } from 'enable-ui';

import type {
  CfsResult,
  CfsResultReport,
  FropResultReport,
  OnBoardingResultReport,
  OnboardingResult,
  SurveyResultReport,
} from './type';

export const getSurveyResult = (
  learnerId: string,
  callback: (data: SurveyResultReport | null) => void,
) => {
  showPageLoading();
  axios
    .get(`/learners/${learnerId}/results/survey`)
    .then((res: AxiosResponse<SurveyResultReport>) => {
      callback(res.data);
      hidePageLoading();
    })
    .catch((err) => {
      showToastMessage('error', err.message);
      callback(null);
      hidePageLoading();
    });
};

export const getFropResult = (learnerId: string, callback: (data: FropResultReport) => void) => {
  showPageLoading();
  axios
    .get(`/learners/${learnerId}/results/frop`)
    .then((res: AxiosResponse<FropResultReport>) => {
      callback(res.data);
      hidePageLoading();
    })
    .catch((err) => {
      showToastMessage('error', err.message);
      callback({ questions: [], results: [] });
      hidePageLoading();
    });
};

export const getCfsResult = (learnerId: string, callback: (data: CfsResultReport) => void) => {
  showPageLoading();
  axios
    .get(`/learners/${learnerId}/results/cfs`)
    .then((res: AxiosResponse<CfsResult[]>) => {
      callback({
        results: res.data,
      });
      hidePageLoading();
    })
    .catch((err) => {
      showToastMessage('error', err.message);
      callback({ results: [] });
      hidePageLoading();
    });
};

export const getOnBoardingResult = (
  learnerId: string,
  callback: (data: OnBoardingResultReport) => void,
) => {
  showPageLoading();
  axios
    .get(`/learners/${learnerId}/results/onboarding-assessment`)
    .then((res: AxiosResponse<OnboardingResult[]>) => {
      callback({
        results: res.data,
      });
      hidePageLoading();
    })
    .catch((err) => {
      showToastMessage('error', err.message);
      callback({ results: [] });
      hidePageLoading();
    });
};
